import { render, staticRenderFns } from "./PrintableCollection.vue?vue&type=template&id=b9041548&scoped=true&"
import script from "./PrintableCollection.vue?vue&type=script&lang=js&"
export * from "./PrintableCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9041548",
  null
  
)

export default component.exports